import { render, staticRenderFns } from "./CountSchoolsWithoutModulesOnCycle.vue?vue&type=template&id=6526556e"
import script from "./CountSchoolsWithoutModulesOnCycle.vue?vue&type=script&lang=js"
export * from "./CountSchoolsWithoutModulesOnCycle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports